var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('keep-alive',{attrs:{"include":['GridView']}},[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.isLoading)?_c('AppLoadingState'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }